<template>
  <div>
    <b-card class="mb-2">
      <div slot="header">
        <b v-text="audienceInfo" />
      </div>
      <LoadingSpinner :loading="loadingAzmoon_audince" />
      <b-row v-if="!loadingAzmoon_audince && audience_azmoon.length">
        <b-col
          :key="index + `research`"
          class="m-1"
          cols="12"
          v-for="(button, index) in audience_azmoon"
        >
          <a
            :href="button.address"
            class="btn btn-info text-white mr-2"
            target="_blank"
          >
            {{ button.exam_pack && button.exam_pack.name }}
          </a>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col v-if="!loadingAzmoon_audince && emptyError">
          <b-alert show variant="danger" v-text="emptyError" />
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mb-2">
      <div slot="header">
        <b v-text="masterInfo" />
      </div>
      <LoadingSpinner :loading="loadingAzmoon_master" />
      <b-row v-if="!loadingAzmoon_master && master_azmoon.length">
        <b-col
          :key="index + `research`"
          class="m-1"
          cols="12"
          v-for="(button, index) in master_azmoon"
        >
          <a
            :href="button.address"
            class="btn btn-info text-white mr-2"
            target="_blank"
          >
            {{ button.exam_pack && button.exam_pack.name }}
          </a>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col v-if="!loadingAzmoon_master && emptyError">
          <b-alert show variant="danger" v-text="emptyError" />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col cols="12" md="12" class="px-0 mb-3">
        <UploadFile
          title="پیوست‌های مسئول پذیرش"
          keyServies="interview_location_person"
          :keyValue="keyValue"
          :file_types="file_types"
          attachmentRoute="attachment_interview_accepting"
          :parentPermissions="parentPermissions"
          :showAdd="false"
          :outButton="outButton"
        />
      </b-col>
      <b-col cols="12" md="12" class="px-0">
        <UploadFile
          title="پیوست‌های استاد مصاحبه"
          keyServies="interview_done"
          :keyValue="interviewDoneId"
          :file_types="file_types"
          attachmentRoute="attachment_interview_doing"
          :parentPermissions="parentPermissions"
          :showAdd="false"
          :outButton="outButton"
        />
      </b-col>
      <b-col class="float-right" cols="12" md="12">
        <div class="form-group form-btn" slot="footer">
          <b-button
            @click="cancel"
            class="ml-2"
            size="md"
            type="reset"
            variant="danger"
          >
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { pathOr } from "ramda";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import UploadFile from "@/components/base/uploadFile.vue";

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    LoadingSpinner,
    UploadFile,
  },
  inject: ["interviewAzmoonExecutePersonRepository"],
  data() {
    return {
      file_types: ["image", "office", "media", "other"],

      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      audience_azmoon: [],
      master_azmoon: [],
      parentPermissions: ["view"],
      loadingAzmoon_audince: false,
      loadingAzmoon_master: false,
      emptyError: "",
      outButton: [
        {
          id: "1",
          name: "edit",
        },
        {
          id: "1",
          name: "download",
          href: true,
        },
      ],
    };
  },
  computed: {
    audienceInfo() {
      const azmoonCaption = pathOr(
        "",
        ["audience", "azmoon", "caption"],
        this.item
      );
      const azmoonId = pathOr("", ["audience", "azmoon", "id"], this.item);
      const checkAzmoon = azmoonId
        ? `(${azmoonCaption} - شماره آزمون: ${azmoonId} )`
        : "";
      return `${this.$lang.views_all_azmoon_exampack} - ${this.$lang.person_exam} ${checkAzmoon}`;
    },
    masterInfo() {
      const azmoonCaption = pathOr(
        "",
        ["master", "azmoon", "caption"],
        this.item
      );
      const azmoonId = pathOr("", ["master", "azmoon", "id"], this.item);
      const checkAzmoon = azmoonId
        ? `(${azmoonCaption} - شماره آزمون: ${azmoonId} )`
        : "";
      return `${this.$lang.views_all_azmoon_exampack} - ${this.$lang.interview_master} ${checkAzmoon}`;
    },
    keyValue() {
      return pathOr(
        null,
        ["audience", "interview_location_person_id"],
        this.item
      );
    },
    interviewDoneId() {
      return pathOr(null, ["id"], this.item);
    },
  },
  methods: {
    pathOr,
    cancel() {
      this.$emit("cancel");
    },
    async getAzmoonExecutePerson(
      azmoon_id,
      person_code,
      operator_code,
      reference_code
    ) {
      try {
        const response = await this.interviewAzmoonExecutePersonRepository.list(
          azmoon_id,
          person_code,
          operator_code,
          reference_code
        );

        return pathOr([], ["data", "data"], response);
      } catch (err) {
        this.$generateError(err);
      }
    },
    async getAudienceAzmoonData() {
      const azmoonId = pathOr(null, ["audience", "azmoon", "id"], this.item);
      const audience_parvandeh_code = pathOr(
        null,
        ["audience", "parvandeh", "code"],
        this.item
      );
      const master_parvandeh_code = pathOr(
        null,
        ["master", "parvandeh", "code"],
        this.item
      );
      const reference_person_code = pathOr(
        null,
        ["audience", "person", "code"],
        this.item
      );

      this.generateEmptyError(azmoonId);

      if (
        !azmoonId ||
        !audience_parvandeh_code ||
        !master_parvandeh_code ||
        !reference_person_code
      )
        return;

      try {
        this.loadingAzmoon_audince = true;
        const firstAzmoonData = await this.getAzmoonExecutePerson(
          azmoonId,
          audience_parvandeh_code,
          master_parvandeh_code,
          reference_person_code
        );
        this.audience_azmoon = [...this.audience_azmoon, ...firstAzmoonData];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingAzmoon_audince = false;
      }
    },
    async getMasterAzmoonData() {
      const azmoonId = pathOr(null, ["master", "azmoon", "id"], this.item);
      const master_parvandeh_code = pathOr(
        null,
        ["master", "parvandeh", "code"],
        this.item
      );
      const master_person_code = pathOr(
        null,
        ["master", "person", "code"],
        this.item
      );

      this.generateEmptyError(azmoonId);

      if (
        !azmoonId ||
        !master_parvandeh_code ||
        !master_parvandeh_code ||
        !master_person_code
      )
        return;

      try {
        this.loadingAzmoon_master = true;
        const secondAzmoonData = await this.getAzmoonExecutePerson(
          azmoonId,
          master_parvandeh_code,
          master_parvandeh_code,
          master_person_code
        );
        this.master_azmoon = [...this.master_azmoon, ...secondAzmoonData];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingAzmoon_master = false;
      }
    },
    generateEmptyError(id) {
      this.emptyError = id ? this.$lang.interviewLang.no_exist_exam_pack : "";
    },
  },
  created() {
    this.getAudienceAzmoonData();
    this.getMasterAzmoonData();
  },
};
</script>
